// =============================================================================
// PastilleCompteur.js — la pastille numérique d'une entrée de menu (lot
// L11d-bis). Le chiffre vient de `compteur`, posé par buildNavModules
// (navConstants.js) sur l'entrée visible : rail, sommaire, tiroir et feuille
// « Modules » lisent tous la même valeur. Chiffre EXACT (jamais « 9+ ») ;
// rien à 0 ni quand on ne sait pas (null). Classe partagée .cq-compteur-nav,
// dérivée de .cq-compteur (coquilleStyles.js).
// =============================================================================
import React from "react";

/** @param {{ n: number, libelle: string } | null} compte  compteEntree / compteModule */
export default function PastilleCompteur({ compte }) {
  if (!compte || !(compte.n > 0)) return null;
  return (
    <span className="cq-compteur cq-compteur-nav" role="img" aria-label={compte.libelle}>{compte.n}</span>
  );
}
